import { render, staticRenderFns } from "./eventCertificate.vue?vue&type=template&id=70fb67b3&scoped=true"
import script from "./eventCertificate.vue?vue&type=script&lang=js"
export * from "./eventCertificate.vue?vue&type=script&lang=js"
import style0 from "./eventCertificate.vue?vue&type=style&index=0&id=70fb67b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb67b3",
  null
  
)

export default component.exports